<template>
    <!-- This one will always just use InputNullableInt and should therefore never be wrappet in a element -->
    <InputNullableInt
        v-model="nonNullValue"
        ref="inputref"
        :placeholder="props.placeholder"
        :validator="props.validator"
        :autofocus="props.autofocus"
        :disabled="props.disabled"
        :readonly="props.readonly"
        :icon="props.icon"
        :icon-family="props.iconFamily"
        :id="props.id"
        :label="props.label"
        :label-position="props.labelPosition"
        :maxlength="props.maxlength"
        :select-on-focus="props.selectOnFocus"
        :mark-text-part="props.markTextPart"
        :model-modifiers="modelModifiers"
        :posttext="props.posttext"
        :tooltip="props.tooltip"
    />
</template>
<script setup lang="ts">
import { InputNullableInt, type IInputIntModelValueType, type IInputIntPropsWithoutModelValue } from '@/components';
import { computed, ref } from 'vue';

const props = withDefaults(defineProps<IInputIntPropsWithoutModelValue>(), {
    validator: null,
});

const modelValue = defineModel<IInputIntModelValueType>({ required: true });

const nonNullValue = computed<number>({
    get() {
        return modelValue.value ?? 0;
    },
    set(value) {
        if (value != null) {
            modelValue.value = value;
        }
    },
});

const inputref = ref();

defineExpose({
    focus: () => inputref.value?.focus(),
    KeyboardEvent: (ev: KeyboardEvent) => {
        const input = ev.key;
        if (!isNaN(Number(input))) {
            nonNullValue.value = Number(input);
            return;
        }
        throw new Error(`Cannot parse input '${input}' to integer`);
    },
});
</script>
